module.exports = __webpack_public_path__ + "img/exportExcel.e22ba246.svg";